// extracted by mini-css-extract-plugin
export var width100 = "D_w d_w";
export var design3Pos = "D_wl d_0";